import {
  AssociatedProperty,
  IAssociatedProperty,
} from '@app/models/AssociatedProperty'
import {
  actionCreators,
  IGlobalPropertiesState,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import Select, { ActionMeta, SingleValue } from 'react-select'
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters'

interface IAssociatedPropertySelectorProps {
  name?: string
  onChange: (newValue: AssociatedProperty) => void
  placeholder?: string
  required?: boolean
  invalid?: boolean
  value: IAssociatedProperty | undefined
}

type AssociatedPropertySelectorProps = IAssociatedPropertySelectorProps &
  IGlobalPropertiesState &
  typeof actionCreators

export class AssociatedPropertySelector extends React.PureComponent<
  AssociatedPropertySelectorProps
> {
  private selectRef: React.RefObject<HTMLDivElement>

  constructor(props: AssociatedPropertySelectorProps) {
    super(props)
    this.selectRef = React.createRef()
    bindFunctions(this)
  }

  public componentDidMount() {
    this.props.getPropertiesList()
    this._checkValidity()
  }

  public componentDidUpdate() {
    this._checkValidity()
  }

  public render() {
    return (
      <div ref={this.selectRef}>
        <Select
          filterOption={this._filterOption}
          onChange={this._onChange}
          formatOptionLabel={this._renderPropertyOptions}
          //optionRenderer={this._renderPropertyOptions}
          options={this.props.properties.results.toArray()}
          placeholder={this.props.placeholder || 'Add properties...'}
          required={this.props.required}
          value={this.props.value}
          getOptionValue={(opt) => opt.propertyId}
          getOptionLabel={(opt) => opt.name}
        />
      </div>
    )
  }

  private _checkValidity() {
    if (this.selectRef.current) {
      const inputElem = this.selectRef.current.querySelector('input:invalid')
      if (inputElem) {
        this.selectRef.current.classList.add('invalid')
      } else {
        this.selectRef.current.classList.remove('invalid')
      }
    }
  }

  private _filterOption(
    option: FilterOptionOption<IAssociatedProperty>,
    filter: string,
  ): boolean {
    const lOption = option || undefined
    const lFilter = filter.toLowerCase()

    return (
      lOption !== undefined &&
      (lOption.value.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.data.address.line1.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.data.address.line2.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.data.address.city.toLowerCase().indexOf(lFilter) >= 0)
    )
  }

  private _onChange(
    newValue: SingleValue<IAssociatedProperty>,
    actionMeta: ActionMeta<IAssociatedProperty>,
  ) {
    this.props.onChange((newValue as AssociatedProperty) || undefined)
  }

  private _renderPropertyOptions(option: any) {
    return (
      <div>
        <div>
          <div>{option.name}</div>
        </div>
        <div>
          <div className='small text-muted'>
            {formatAddressSingleLine(option.address)}
          </div>
        </div>
      </div>
    )
  }
}
